<template>
  <div class="panel-result-data">
    <div class="panel-result-data-name">
      <div class="circle" :style="{ backgroundColor }"></div>
      <div class="label">{{ label }}</div>
    </div>
    <div class="ratio">
      {{ total !== 0 ? Math.round((value / total) * 100) : 0 }}%
    </div>
    <div class="amount">{{ value }} / {{ total }}</div>
  </div>
</template>

<script>
export default {
  name: 'PanelResultData',
  props: {
    backgroundColor: {
      type: String,
    },
    label: {
      type: String,
      default: () => {
        ''
      },
    },
    value: {
      type: Number,
    },
    total: {
      type: Number,
    },
  },
}
</script>

<style lang="less" scoped>
.panel-result-data {
  display: flex;

  &-name {
    display: flex;
    align-items: center;
    flex: 2;
    min-width: 160px;

    .circle {
      width: 9px;
      height: 9px;
      border-radius: 50%;
      margin-right: 10px;
    }

    .label {
      white-space: nowrap;
      min-width: 100px;
    }
  }

  .ratio {
    color: #8b8d97;
    flex: 1;
  }

  .amount {
    margin-left: 22px;
    white-space: nowrap;
    flex: 1;
    min-width: 60px;
  }
}
</style>
